import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";

import Dashboard from "./Dashboard";
import Footer from "../partials/footer";
import Navigation from "../partials/navigation";
import NotFound from "./NotFound";
import MainNavigation from "./Patient/partial/MainNavigation";
import View from "./Patient/View";
import Home from "./Home";
import Appointment from "./Appointment";
import FetchPatient from "./QuickAccess/FetchPatient";
import SearchPatients from "./Patient/SearchPatients";

class Landing extends Component {
    render() {
        return (
            <>
                <div className="page-wrapper">
                    {/* Very top navigation */}
                    <Navigation history={this.props.history} />

                    <div className="page-container">
                        {/* Side bar */}
                        {/* <Sidebar /> */}
                        <div className="page-content-wrapper page-content-wrapper-home">
                            <MainNavigation />
                            <div className="page-content page-content-home">
                                <Switch>
                                    <Route exact path="/home/clinical-note" component={Dashboard} />
                                    <Route path="/home/clinical-note/scanner" component={FetchPatient} />
                                    <Route path="/home/clinical-note/appointment" component={Appointment} />
                                    <Route path="/home/clinical-note/admin" component={Home} />
                                    <Route path="/home/clinical-note/ward-summary" component={View} />
                                    <Route path="/home/clinical-note/search/:keyword" component={SearchPatients} />
                                    <Route component={NotFound} />
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
                {/* App footer goes here */}
                <Footer />
            </>
        );
    }
}

export default Landing;
